import styled from "styled-components";

export const Container = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  margin-bottom: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 15px;
    color: #071242;
    font-weight: bold;
    text-align: center;

    margin-bottom: 13px;
  }
`;

export const ListaCategorias = styled.div`
  display: block;
  justify-content: center;
`;
